<template>
  <div>
    <label class="block font-bold mb-2">{{ field.name }}</label>
    <ul>
      <li v-for="(label, value) in field.options" :key="value">
        {{ label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['resourceName', 'field', 'resourceId'],
};
</script>
